export default __webpack_public_path__ + "static/media/tooltip_white_icon.b7bee50b.svg";